import React, { useState } from "react";
import "./Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import EliteLogo from "../Includes/Images/elitesyc.png";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreaters } from "../../Redux";

export default function Navbar() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const userActions = bindActionCreators(actionCreaters, dispatch);
  const navigate = useNavigate();

  const state = useSelector((state) => state.stateVals);
  const { role } = state;
  let link = role === "cards" ? "/list-cards" : "/rsa";

  const logOut = async (e) => {
    e.preventDefault();
    setLoading(true);
    userActions.logOut(null);
    setLoading(false);
    navigate("/");
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      {/* <Link className="navbar-brand" to={link}> */}
      <Link className="navbar-brand" to="/registered-users/production">
        <img src={EliteLogo} className="eliteLogo" />
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav me-auto">
          {role == "city" && (
            <>
              <li className="nav-item active">
                <Link className="nav-link" to="/registered-users/production">
                  Production <span className="sr-only">(current)</span>
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/registered-users/sandBox">
                  SandBox
                </Link>
              </li>
            </>
          )}
        </ul>

        <Link
          className="logout-btn"
          to="/"
          onClick={(e) => {
            logOut(e);
          }}
        >
          <i className="bi bi-box-arrow-right"></i> Logout
        </Link>
        <br id="space" />
      </div>
    </nav>
  );
}
